/**
 * 内置提供商适配器注册（T15）。
 *
 * `ProviderRegistry` 构造时自带 `openai` 与 `custom`；`anthropic` / `gemini`
 * 的工厂已在 `src/core/providers/` 实现，但默认注册表尚未登记（core 侧注释明确
 * 标注「由 T15 注册」）。本模块用注册表的公开 API 在运行时补齐 —— 这是注册表
 * 设计上支持的用法，**不改动 `src/core/**` 的既有实现**。
 */
import { createAnthropicAdapter } from '../../core/providers/anthropic';
import { createGeminiAdapter } from '../../core/providers/gemini';
import { createOpenAIAdapter } from '../../core/providers/openai';
import { defaultProviderRegistry } from '../../core/providers/registry';
import type { ProviderAdapterFactory } from '../../core/providers/types';

/** 四个内置 kind 对应的工厂（custom 复用 OpenAI 兼容协议）。 */
export const BUILTIN_PROVIDER_FACTORIES: Record<string, ProviderAdapterFactory> = {
  openai: createOpenAIAdapter,
  anthropic: createAnthropicAdapter,
  gemini: createGeminiAdapter,
  custom: createOpenAIAdapter,
};

/** 幂等注册全部内置 kind；重复调用不会覆盖已注册工厂。 */
export function ensureBuiltinProviderKinds(): void {
  for (const [kind, factory] of Object.entries(BUILTIN_PROVIDER_FACTORIES)) {
    if (!defaultProviderRegistry.has(kind)) defaultProviderRegistry.register(kind, factory);
  }
}